import { createFileRoute } from '@tanstack/react-router'
import { DropshipDraftListPage } from '@/pages/dropship-draft-list'

export const Route = createFileRoute('/_authenticated/projects/dropship-drafts/')({
  staticData: { title: 'Quote Drafts' },
  component: DropshipDraftListPage,
})
